module.exports = __webpack_public_path__ + "static/media/HomeDesk2-opt.08f00053.jpg";